"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const SlideHeaderWithNav_vue_1 = tslib_1.__importDefault(require("../SlideHeaderWithNav.vue"));
const ContainerSlide_vue_1 = tslib_1.__importDefault(require("../ContainerSlide.vue"));
const Disclosure_vue_1 = tslib_1.__importDefault(require("../Disclosure.vue"));
const ElementIds_1 = require("../../enums/ElementIds");
exports.default = vue_1.default.extend({
    name: 'forgot-password-disclosure',
    data: () => {
        return {
            disclosureAccepted: false,
        };
    },
    computed: {
        currentChallenge() {
            return this.$store.state.currentChallenge;
        },
        canContinue() {
            return !this.disclosureAccepted;
        },
        disclosureContent() {
            return this.$store.state.currentChallenge.DisclosureContent || '';
        },
        disclosureID() {
            return this.$store.state.currentChallenge.DisclosureId || '';
        },
        doesDisclosureExists() {
            return this.disclosureContent !== '';
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        submitting() {
            return this.$store.getters.isSubmittingChallenge;
        },
        hasError() {
            return (this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Success &&
                this.$store.state.challengeStatus !== ChallengeStatus_1.ChallengeStatus.Unknown);
        },
        elementIds: () => ElementIds_1.ElementIds,
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        async submitForm() {
            if (this.submitting || !this.disclosureAccepted) {
                return;
            }
            const challenge = {
                ...this.currentChallenge,
                DisclosureID: this.disclosureID,
                Accepted: this.disclosureAccepted,
            };
            // reset the challenge status before submitting so we pick up a new one
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            // submit the challenge
            await this.$store.dispatch('submitChallenge', challenge);
        },
        toggleAccepted() {
            this.disclosureAccepted = !this.disclosureAccepted;
        },
    },
    mounted() {
        this.$refs.heading.focus();
    },
    components: {
        SlideHeaderWithNav: SlideHeaderWithNav_vue_1.default,
        ContainerSlide: ContainerSlide_vue_1.default,
        Disclosure: Disclosure_vue_1.default,
    },
});
